import type { AppDispatch } from '@store';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { commonApiSlice } from '@api/commonApiSlice';
import { setToken, setUserConfig } from '@features/auth/store/authSlice';
import { catchCommonError } from '@utils/catchCommonError';
import { isEnumEqual } from '@utils/isEnumEqual';

import { SYSTEM_ROLES } from '@constants';

export const fetchUserConfig = createAsyncThunk<
  void,
  string,
  { dispatch: AppDispatch }
>('auth/fetchUserConfig', async (token, { dispatch }) => {
  dispatch(setToken(token));

  try {
    const userConfig = await dispatch(
      commonApiSlice.endpoints.getUserConfig.initiate('')
    ).unwrap();

    const { brands, userId, userType, username, permissions } =
      userConfig ?? {};

    const superPermissions: SYSTEM_ROLES.PERMISSION[] = isEnumEqual(
      userType,
      SYSTEM_ROLES.ROLE.SUPER_ADMIN
    )
      ? Object.entries(SYSTEM_ROLES.PERMISSION).map((p) => p[1])
      : [];

    dispatch(
      setUserConfig({
        brands,
        userId,
        userType,
        username,
        permissions: [...superPermissions, ...permissions],
      })
    );
  } catch (error) {
    catchCommonError(error);
  }
});
